import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs';

export interface GeoLocationResult {
    countryCode: string;
    countryName: string;
    region: string;
    city: string;
    latitude: number;
    longitude: number;
}

export interface CurrencyPair {
    currency: string;
    forAmount: number;
    exchangeRate: number;
}

export const CURRENCY_SYMBOLS: Record<string, string> = {
    EUR: '\u20AC', USD: '$', GBP: '\u00A3', CHF: 'CHF', JPY: '\u00A5',
    AUD: 'A$', CAD: 'C$', CNY: '\u00A5', CZK: 'K\u010D', DKK: 'kr',
    HUF: 'Ft', INR: '\u20B9', KWD: 'KD', NOK: 'kr', RUB: '\u20BD',
    SEK: 'kr', AED: 'AED', MKD: 'den', TRY: '\u20BA', RON: 'lei',
    BAM: 'KM', PLN: 'z\u0142', BYN: 'Br', RSD: 'din',
    ATS: 'ATS', BEF: 'BEF', FIM: 'FIM', FRF: 'FRF', DEM: 'DM',
    GRD: 'GRD', IEP: 'IEP', ITL: 'ITL', LUF: 'LUF', PTE: 'PTE',
    ESP: 'ESP'
};

export function getCurrencySymbol (code: string): string {
    return CURRENCY_SYMBOLS[code] || code;
}

export const COUNTRY_TO_CURRENCY: Record<string, string> = {
    // Eurozone
    AT: 'EUR', BE: 'EUR', CY: 'EUR', EE: 'EUR', FI: 'EUR', FR: 'EUR',
    DE: 'EUR', GR: 'EUR', IE: 'EUR', IT: 'EUR', LV: 'EUR', LT: 'EUR',
    LU: 'EUR', MT: 'EUR', NL: 'EUR', PT: 'EUR', SK: 'EUR', SI: 'EUR',
    ES: 'EUR', HR: 'EUR',
    // Other currencies on NBS list
    US: 'USD', GB: 'USD', AU: 'AUD', CA: 'CAD', CN: 'CNY', CZ: 'CZK',
    DK: 'DKK', HU: 'HUF', IN: 'INR', JP: 'JPY', KW: 'KWD', NO: 'NOK',
    RU: 'RUB', SE: 'SEK', CH: 'CHF', LI: 'CHF', AE: 'AED', MK: 'MKD',
    TR: 'TRY', RO: 'RON', BA: 'BAM', PL: 'PLN', BY: 'BYN',
    // GB uses GBP
    UK: 'GBP',
};
// Fix GB mapping
COUNTRY_TO_CURRENCY['GB'] = 'GBP';

export function getCurrencyForCountry (countryCode: string): string | null {
    return COUNTRY_TO_CURRENCY[countryCode.toUpperCase()] || null;
}

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private http = inject(HttpClient);

    getExchangeRates (): Observable<CurrencyPair[]> {
        return this.http.get<CurrencyPair[]>(`${environment.serviceUrl}/currency/`);
    }

    getGeoLocation (): Observable<GeoLocationResult> {
        return this.http.get<GeoLocationResult>(`${environment.serviceUrl}/geo-location`);
    }
}
